module.exports = __webpack_public_path__ + "static/media/testimonio.d3eb5716.jpg";